import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class NewIncidentService {
  _uri = this.environment.incidentBaseUrl;
  incidentCreated = new BehaviorSubject<boolean>(false);
  menuToggle = new BehaviorSubject<boolean>(false);
  actionTabExist = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, public environment: EnvService) {}

  setIncidentCreated(hasValue) {
    this.incidentCreated.next(hasValue);
  }

  getIncidentCreated(): Observable<boolean> {
    return this.incidentCreated.asObservable();
  }

  getCompanies(params: any) {
    return this.http.post<any>(`${this._uri}incident/get/companies`, params);
  }

  getCompanyCategories(params: any) {
    return this.http.post<any>(`${this._uri}incident/get/categories`, params);
  }

  getChecklist(params: any) {
    return this.http.post<any>(`${this._uri}incident/get/checklist`, params);
  }

  getIncidentTypes(params: any) {
    return this.http.post<any>(`${this._uri}incident/type/list`, params);
  }

  getIncidentSeverity(params: any) {
    return this.http.post<any>(`${this._uri}incident/severity/list`, params);
  }

  createIncident(params: any) {
    return this.http.post<any>(`${this._uri}incident/create/incident`, params);
  }

  updateIncident(params: any) {
    return this.http.post<any>(`${this._uri}incident/update/incident`, params);
  }

  actionPlanRequired(params: any) {
    return this.http.post<any>(`${this._uri}incident/actionplan/required`, params);
  }

  getActionPlan(params: any) {
    return this.http.post<any>(`${this._uri}incident/get/actionplan`, params);
  }

  actionPlanSave(params: any) {
    return this.http.post<any>(`${this._uri}incident/action/save`, params);
  }
  setMenuToggleOff(value: boolean) {
    this.menuToggle.next(value);
  }

  setActionMenu(value: boolean) {
    this.actionTabExist.next(value);
  }
  actionPlanDelete(params: any) {
    return this.http.post<any>(`${this._uri}incident/action/delete`, params);
  }
}
